const dataBlog = [
  {
    img: "common-types.svg",
    title: "مقیاس‌پذیری",
    desc: "با تغییر نیازهای کسب‌وکارتان هیچ محدودیتی برای افزایش یا کاهش میزان منابع مورد تقاضای شما وجود ندارد! در ابر «آبالون»، ارتقای حافظه، میزان فضای ذخیره‌سازی، افزایش تعداد پردازنده‌ها و… برای پشتیبانی از کاربران بیشتر، فقط در عرض چند ثانیه بدون هیچ‌گونه وقفه عملیاتی امکان‌پذیر است و این ویژگی، سرورهای ابری «آبالون» را به گزینه‌ای ایده‌آل برای شرکت‌هایی تبدیل می‌کند که در حال رشد هستند.",
    alt: "مقیاس‌پذیری",
  },
  {
    img: "Google.svg",
    title: "اطمینان بالا",
    desc: "سرورهای ابری اتصالی مطمئن، بدون وقفه و با سرعت بالا را برای کاربران فراهم می‌کنند. این سرورها برای به اشتراک گذاشتن قدرت پردازش خود توسط فناوری موسوم به رایانش ابری در استخری از منابع به یکدیگر متصل می‌شوند، در نتیجه مجموعه‌هایی که از زیرساخت‌های ابری برای ارائه خدمات خود استفاده ‌می‌کنند می توانند پایداری و اطمینان صد در صدی را تجربه کنند.",
    alt: "اطمینان بالا",
  },
  {
    img: "everything.svg",
    title: "بهینه‌سازی منابع",
    desc: "با استفاده از سرویس‌های ابری، علاوه بر بهینه‌سازی منابع مالی خود جهت خرید سخت‌افزار و فرآیند پیچیده نگهداری از آن‌ها، تمرکز تیم زیرساخت خود را بر هسته اصلی کسب‌وکار معطوف خواهید کرد و آن‌ها دیگر درگیر مسائل نصب و راه‌اندازی و نگهداری زیرساخت‌های پردازشی نخواهند شد.",
    alt: "بهینه‌سازی منابع",
  },
  {
    img: "python.svg",
    title: "امنیت پیشرفته",
    desc: "با تغییر نیازهای کسب‌وکارتان هیچ محدودیتی برای افزایش یا کاهش میزان منابع مورد تقاضای شما وجود ندارد! در ابر «آبالون»، ارتقای حافظه، میزان فضای ذخیره‌سازی، افزایش تعداد پردازنده‌ها و… برای پشتیبانی از کاربران بیشتر، فقط در عرض چند ثانیه بدون هیچ‌گونه وقفه عملیاتی امکان‌پذیر است و این ویژگی، سرورهای ابری «آبالون» را به گزینه‌ای ایده‌آل برای شرکت‌هایی تبدیل می‌کند که در حال رشد هستند.",
    alt: "وبینار آبالون",
  },
  {
    img: "top-ways.svg",
    title: "انعطاف‌پذیری",
    desc: "با منابعی که نیاز دارید، سریع و آسان شروع کنید! سپس با توجه به نیاز کسب‌وکارتان، تنها با چند کلیک افزایش یا کاهش منابع دهید! بعلاوه، سرورهای ابری می‌توانند با تغییرات سریع برای نیازهای مختلف، بارهای کاری متنوعی را در خود جای دهند. در ابر «آبالون» می‌توانید به راحتی، ویژگی‌های سرور ابری خود را با استفاده از داشبورد مدیریت ابری اختصاصی خود کنترل کنید.",
    alt: "انعطاف‌پذیری",
  },
  {
    img: "Google.svg",
    title: "انعطاف‌پذیری",
    desc: "با منابعی که نیاز دارید، سریع و آسان شروع کنید! سپس با توجه به نیاز کسب‌وکارتان، تنها با چند کلیک افزایش یا کاهش منابع دهید! بعلاوه، سرورهای ابری می‌توانند با تغییرات سریع برای نیازهای مختلف، بارهای کاری متنوعی را در خود جای دهند. در ابر «آبالون» می‌توانید به راحتی، ویژگی‌های سرور ابری خود را با استفاده از داشبورد مدیریت ابری اختصاصی خود کنترل کنید.        ",
    alt: "انعطاف‌پذیری",
  },
];
const benefits = [
  {
    title: "قابلیت انتخاب سطح سرویس",
    logo: "sla.svg",
  },
  {
    title: "پشتیبانی 365 / 24 / 7",
    logo: "support.svg",
  },
  {
    title: "زیرساخت‌های ایمن",
    logo: "infrustructure.svg",
  },
  {
    title: "داشبورد ابری یکپارچه و جامع ",
    logo: "dashboard.svg",
  },
  {
    title: "کیفیت بالای CPU، RAM و حافظه‌ها",
    logo: "hq.svg",
  },
  {
    title: "پشتیبانی فنی رایگان",
    logo: "freeSupport.svg",
  },
];

const questions = [
  {
    title: "دیتاسنتر ابری آبالون چیست؟",
    answer:
      "دیتاسنتر ابری یا وی پی سی، خدمتی در لایه زیرساخت ابری‌ست (Infastructure as a Service) که همه امکانات یک دیتاسنتر فیزیکی را روی محیط ابری برای شما فراهم می‌سازد. با خرید VPC از هزینه خرید و نیز پیچیدگی‌های راه‌اندازی و نگهداری دیتاسنترهای فیزکی رها شده و بر کسب‌وکار خود و راه‌اندازی سرویس‌های مورد نیاز متمرکز می‌شوید.",
  },
  {
    title: "تفاوت بین دیتاسنتر ابری و دیتاسنتر فیزیکی چیست؟",
    answer:
      "سازمان‌ها و شرکت‌ها از دیتاسنتر ابری برای اجرای برنامه‌ها، ایجاد و نگهداری پایگاه‌های داده، میزبانی و راه‌اندازی وب‌سایت‌ها، راه‌اندازی راهکارهای پشتیبان‌گیری و … استفاده می‌کنند. در واقع می‌توانند هر کاری را که تا قبل از این، در دیتاسنترهای فیزیکی انجام می‌دادند در وی پی سی نیز به سادگی و با مقیاسی نامحدود و با دسترسی به یک پنل مدیریتی یکپارچه برای تمامی سرورها، انجام دهند. همچنین سازمان‌ها با خرید VPC برای همیشه دغدغه راه‌اندازی، نگهداری و هزینه‌های عملیاتی سرورها را از خود دور می‌کنند.",
  },
  {
    title: "چه خدمات پشتیبانی همراه دیتاسنتر ابری «آبالون» ارائه می‌شود؟",
    answer:
      "با خرید VPC آبالون از پشتیبانی فنی رایگان و به صورت ۲۴/۷/۳۶۵ بهره‌مند می‌شوید که به روش‌های مختلف در دسترس شما است.",
  },
  {
    title: "چطور باید دیتاسنتر ابری خودم را راه‌اندازی کنم؟",
    answer:
      "برای این‌ کار به مهارت برنامه‌نویسی یا دانش فنی خاصی نیاز ندارید! همه مراحل برای شما ساده‌سازی و از پیش آماده شده است. ابتدا از طریق پنل کاربری آبالون، منابع و سطح کیفی سرویس مورد نظر خود را انتخاب کرده و اقدام به خرید دیتاسنتر ابری کنید. پس از پرداخت هزینه، بلافاصله سرویس را دریافت کرده و ایجاد سرور و تخصیص منابع به آن را آغاز نمایید.",
  },
  {
    title: "قیمت دیتاسنتر ابری چقدر است؟",
    answer:
      "قیمت‌ها بسته به میزان منابع و سطح کیفی سرویسی که انتخاب می‌کنید متفاوت است. تعداد هسته‌های پردازنده، میزان رم و فضای ذخیره‌سازی، تعداد آدرس آی‌پی، میزان ترافیک و سطح کیفیت سرویس از جمله فاکتورهای تأثیرگذار بر قیمت هستند.",
  },
  {
    title: "آیا داده‌های من در وی پی سی امن است؟",
    answer:
      "امنیت داده‌ها در تمامی محصولات و خدمات «آبالون» اولویت اصلی‌ست. این امر در مورد دیتاسنتر ابری نیز صدق می‌کند. زیرساخت امنیتی دیجیتال و فیزیکی ابر «آبالون» از داده‌های شما به طور جامع محافظت می‌کند. با دیتاسنتر ابری «آبالون»، نه تنها از انتقال داده‌های رمزگذاری شده، بلکه از ذخیره‌سازی رمزگذاری شده و پشتیبان‌گیری منظم از داده‌ها نیز بهره‌مند می‌شوید. همچنین مراکز داده ما، شامل سرورهای مدرن با کارایی بالا و لایه‌های محافظتی‌ فیزیکی و دیجیتالی است که از تمامی سرویس‌های وی پی سی در برابر حملات ناخواسته محافظت می‌کند.",
  },
  {
    title: "مزایای دیتاسنتر ابری چیست؟",
    answer:
      "با خرید دیتاسنتر ابری به پنل اوپن استک شخصی‌سازی شده توسط آبالون دسترسی پیدا می‌کنید که امکان ایجاد، پیکربندی و مدیریت تمامی VMها را در محیطی یکپارچه فراهم می‌کند. VPC آبالون همچنین امکان پیاده‌سازی لود بالانسینگ، پشتیبان‌گیری خودکار، ذخیره اسنپ‌شات، بارگذاری ایمیج دلخواه والیوم یا سیستم‌عامل و مدیریت SDN را در اختیارتان قرار می‌دهد. دیگر مزایای وی پی اس شامل کاهش هزینه راه‌اندازی زیرساخت‌های فناوری اطلاعات، آپ‌تایم و امنیت بالا، کنترل کامل بر سرورها و منابع آنها، مهاجرت آنی، خودکار و بدون قطعی سرویس به سخت‌افزار سالم در صورت خراب شدن هر سخت‌افزار (Live Migration) و رهایی از فرایندهای پیچیده و پر هزینه نگهداری سخت‌افزارهای سرور است.",
  },
];
const PopularServices = [
  {
    title: "سرور ابری",
    desc: "سرور ابری آبالون راهکاری ساده، سریع و قدرتمند برای راه‌اندازی زیرساخت کلود است که در عرض یک دقیقه فعال شده و با سیستم‌عامل و منابع دلخواه شما در اختیارتان قرار می‌گیرد.",
    logo: "VPS-Service.svg",
    route: "/vps",
    imgAlt: "سرور ابری",
    imgTitle: "سرور ابری",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت، سرعت بارگذاری و کیفیت سئو وب‌سایت خود را بهبود دهید و به لطف پاپ‌سایت‌های توزیع شده در جهان، داده‌های خود را سریع‌تر و بهینه‌تر به دست کاربران خود برسانید.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN)",
    imgTitle: "شبکه توزیع محتوا (CDN)",
  },

  {
    title: "سرویس مدیریت شده",
    desc: "تحت سرویس‌های مدیریت شده، راهکار اختصاصی سازمان شما در حوزه ابری، از جمله نصب سیستم‌عامل و نرم‌افزارها، هاردنینگ، طراحی معماری و مهاجرت ابری، اجرا می‌شود.",
    logo: "ManagedService-Service.svg",
    route: "/manageservices",
    imgAlt: "سرویس‌های مدیریت شده",
    imgTitle: "سرویس‌های مدیریت شده",
  },
  {
    title: "DNS ابری",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "DNS.svg",
    route: "/dns",
    imgAlt: "DNS ابری",
    imgTitle: "DNS ابری",
  },
];
const benefits2 = [
  {
    name: "قابلیت انتخاب سطح سرویس",
    logo: "sla.svg",
    alt: "امکان انتخاب سطح کیفی سرویس وی پی سی",
    title: "امکان انتخاب سطح کیفی سرویس وی پی سی",
  },
  {
    name: "پشتیبانی 365 / 24 / 7",
    logo: "support.svg",
    alt: "پشتیبانی دائمی دیتاسنتر ابری",
    title: "پشتیبانی دائمی دیتاسنتر ابری",
  },
  {
    name: "زیرساخت‌های ایمن",
    logo: "infrustructure.svg",
    alt: "زیرساخت ایمن دیتاسنتر ابری",
    title: "زیرساخت ایمن دیتاسنتر ابری",
  },
  {
    name: "داشبورد ابری یکپارچه و جامع ",
    logo: "dashboard.svg",
    alt: "پنل جامع وی پی سی",
    title: "پنل جامع وی پی سی",
  },
  {
    name: "کیفیت بالای CPU، RAM و استوریج",
    logo: "hq.svg",
    alt: "کیفیت بالای سخت‌افزار دیتاسنتر ابری",
    title: "کیفیت بالای سخت‌افزار دیتاسنتر ابری",
  },
  {
    name: "پشتیبانی فنی رایگان",
    logo: "freeSupport.svg",
    alt: "پشتیبانی فنی رایگان سرویس دیتاسنتر ابری",
    title: "پشتیبانی فنی رایگان سرویس دیتاسنتر ابری",
  },
];
const customers = [
  {
    name: "خدمات مالی و بیمه",
    title: "بیمه دی",
    banner: "/VPC-insurance.jpg",
    logo: "/day-insurance.png",
    logo_gray: "/day-insurance-gary.png",
    description:
      "تحول دیجیتال و استفاده از فناوری‌های مدرن در حال حاضر یکی از روندهای پویا در صنعت بیمه است. شرکت «بیمه دی» به عنوان یکی از مجموعه‌های بیمه‌ای پیشرو در این حوزه شناخته می‌شود و یکی از دغدغه‌ها و موضوعات مهم برای آن‌ها در بخش IT، استفاده از قابلیت افزایش یا کاهش منابع در لحظه و کنترل و بهینه‌سازی هزینه‌ها  بوده که راه‌حل آن را در استفاده از فناوری ابری پیدا کردند. آن‌ها تمایل داشتند تا وارد بازی سخت و پیچیده خرید و نگهداری دیتاسنترهای سنتی با دغدغه‌های تمام‌نشدنی‌اش نشوند! و اینجا آغاز همکاری و همراهی بیمه «دی» و ابر «آبالون» برای راه‌اندازی  «دیتاسنتر ابری» بود.",
    banner_alt: "بیمه دی مشتری آبالون",
    logo_alt: "بیمه دی",
    logo_title: "بیمه دی",
  },
  {
    name: "نوآوری و تکنولوژی",
    title: "دیجی‌نکست",
    banner: "/VPC-innovation.jpg",
    logo: "/diginext.png",
    logo_gray: "/diginext-gray.png",
    description:
      "مجموعه‌ای که به عنوان یک شتاب‌دهنده بزرگ، به خلق داستان موفقیت استارتاپ‌های زیادی کمک می‌کند! این یک توضیح کوتاه برای معرفی «دیجی‌نکست» است که مرکز نوآوری و سرمایه‌گذاری گروه دیجی‌کالا شناخته می‌شود. با توجه به اینکه آن‌ها زیرساخت‌های IT مورد نیاز استارتاپ‌های‌شان را تأمین می‌کنند، ویژگی مقیاس‌‍پذیری و انعطاف در کاهش یا افزایش منابع چالش بزرگی بود که با دو راهکار ویژه «سرور ابری» و «دیتاسنتر ابری» به میزبانی ابر «آبالون» برای دیجی‌نکست اجرا و پیاده‌سازی شد. تا این مجموعه به راحتی بتواند از طریق داشبورد ابری، منابع و زیرساخت‌های مورد نیاز استارتاپ‌هایش را مدیریت کند.",
    banner_alt: "دیجی نکست مشتری آبالون",
    logo_alt: "دیجی نکست",
    logo_title: "دیجی نکست",
  },
  {
    name: "فناوری اطلاعات",
    title: "ایریسا",
    banner: "/VPC-IT.jpg",
    logo: "/irisa.png",
    logo_gray: "/irisa-gray.png",
    description:
      "جالب است بدانید که مجموعه‌های بزرگی مثل: فولاد مبارکه اصفهان، مخابرات کل کشور، ذوب‌آهن اصفهان، بانک کشاورزی، شرکت پاکسان، شرکت ملی حفاری ایران و… یک پیمانکار IT دارند که مسئولیت تأمین زیرساخت‌های فناوری اطلاعات آن‌ها را به عهده دارد! و شرکت بین‌المللی مهندسی سیستم‌ها و اتوماسیون با نام تجاری «ایریسا» مجموعه‌ای‌ست که این مسئولیت بزرگ را به دوش می‌کشد. در حقیقت «ایریسا» به علت موانع رایج خریداری، راه‌اندازی، نگهداری، مقایس‌پذیری و توسعه در زیرساخت‌های سنتی IT، تصمیم به استفاده از زیرساخت‌های ابری «آبالون» را عملیاتی کرد و در حال حاضر با استفاده از پنل مدیریت منابع ابری، می‌تواند در هر زمانی با توجه به نیاز کاربرانش افزایش یا کاهش منابع را خودش مدیریت کرده و چالش‌های مواجه با زیرساخت‌های سنتی را از فرآیندهای کاری خود حذف کند.",
    banner_alt: "ایریسا مشتری آبالون",
    logo_alt: "ایریسا",
    logo_title: "ایریسا",
  },

  {
    name: "بانک‌ها و موسسات مالی",
    title: "گروه مالی شهر",
    banner: "/VPC-banks.jpg",
    logo: "/shahr-financial-group.png",
    logo_gray: "/shahr-financial-group-gray.png",
    description:
      "بین مجموعه‌هایی که در حوزه خدمات مالی فعالیت می‌کنند، هلدینگ «گروه مالی شهر» یکی از مجموعه‌های پیشرویی بود که توانست برنامه استراتژیک فناوری اطلاعات خودش را همپای تکنولوژی ببیند و پا به جهان بی‌انتهای ابرها بگذارد! این مجموعه که به عنوان بازوی نیرومند «بانک شهر» شناخته می‌شود در حوزه خدمات مالی، سرمایه‌گذاری و شتاب‌دهی کسب‌و‌کارهای نوپا فعالیت می‌کند. اما همکاری ما با «گروه مالی شهر» در حالی اتفاق افتاد که آن‌ها انعطاف‌پذیری، انطباق، قدرت پردازش و امنیت را در قلب مسیر توسعه خدمات IT خود قرار دادند و محصول «دیتاسنتر ابری» به میزبانی ابر «آبالون» را راه‌حل ویژه برای پاسخ شایسته به این چالش انتخاب کردند.",
    banner_alt: "گروه مالی شهر مشتری آبالون",
    logo_alt: "گروه مالی شهر",
    logo_title: "گروه مالی شهر",
  },
];
const uses = [
  {
    img: "container.svg",
    name: "پیاده‌سازی راهکارهای مبتنی بر کانتِینر",
    desc: "با دیتاسنتر ابری، راهکار مبتنی بر کانتینر دلخواه خود از جمله داکر سوارم، کوبرنتیز، اوپن شیفت، مزوس یا نومد را راه‌اندازی کنید و از سرعت بالای اجرای نرم‌افزارها، بهینگی بالاتر در استفاده از منابع و سرویس‌دهی همیشگی به کاربران بهره‌مند شوید.",
    alt: "اجرای راهکارهای کانتینری با خرید وی پی سی",
    title: "اجرای راهکارهای کانتینری با خرید وی پی سی",
  },
  {
    img: "plans.svg",
    name: "پیاده‌سازی برنامه‌ها و راهکارهای پیچیده",
    desc: "با خرید دیتاسنتر ابری می‌توانید پاسخی برای اجرای راهکارهای نرم‌افزاری پیچیده چندلایه یا راهکارهای با نیاز پردازشی بالا بیابید و چیدمان سرورهای خود را طراحی کرده و پیچیده‌ترین معماری ابری مورد نیازتان را پیاده‌سازی نمایید.",
    alt: "پیاده‌‌سازی راهکارهای پیچیده با وی پی سی",
    title: "پیاده‌‌سازی راهکارهای پیچیده با وی پی سی",
  },
  {
    img: "HA.svg",
    name: "اجرای راهکارهای HA",
    desc: "با راه‌اندازی سرویس‌ها در چندین سرور، از امکان افزایش دسترسی‌پذیری سرویس‌ها (High Availability) بهره‌مند می‌شوید و حتی با از دسترس خارج شدن یکی از سرورها، اطمینان پیدا می‌کنید که سرورهای جایگزین، دسترسی همیشگی را تصمین می‌کنند.",
    alt: "اجرای HA با خرید دیتاسنتر ابری",
    title: "اجرای HA با خرید دیتاسنتر ابری",
  },
  {
    img: "Isolation.svg",
    name: "پاسخی برای نیاز به منابع نامحدود",
    desc: "با خرید VPC، به تعداد هسته پردازنده، میزان رم، استوریج و تعداد آی‌پی نامحدود دسترسی دارید. همچنین می‌‌توانید اطمینان داشته باشید که با بزرگ‌شدن ابعاد سازمان در آینده، با مشکل محدودیت در منابع مواجه نمی‌شوید و در هر لحظه می‌توانید منابع را افزایش دهید.",
    alt: "دسترسی به منابع نامحدود با خرید VPC",
    title: "دسترسی به منابع نامحدود با خرید VPC",
  },
  {
    img: "service.svg",
    name: "اجرای لود بالانسینگ",
    desc: "با VPC می‌توانید برای کسب‌وکارتان که با افزایش ناگهانی بار کاری مواجه می‌شود، Load Balancing را پیاده‌سازی نمایید. به این ترتیب بار کاری، بر اساس الگوریتم مشخص، به صورت خودکار بین سرورهای شما توزیع می‌شود و سرورها همیشه در دسترس باقی می‌مانند.",
    alt: "پیاده‌سازی لود بالانسینگ با خرید دیتاسنتر ابری",
    title: "پیاده‌سازی لود بالانسینگ با خرید دیتاسنتر ابری",
  },
];

const serviceFeatures = [
  {
    title: "پنل پیشرفته مدیریت سرورها",
    desc: "با پنل پیشرفته تحت وب، مدیریت همه VMها را در یک محیط کاربری واحد در دست بگیرید.",
    logo: "panel.svg",
    imgAlt: "پنل پیشرفته مدیریت VMها در دیتاسنتر ابری",
    imgTitle: "پنل پیشرفته مدیریت VMها در دیتاسنتر ابری",
  },
  {
    title: "بارگذاری ایمیج دلخواه شما",
    desc: "در وی پی سی، ایمیج‌های آبالون را انتخاب کنید یا ایمیج سیستم‌عامل یا والیوم دلخواه را آپلود نمایید.",
    logo: "image1.svg",
    imgAlt: "بارگذاری ایمیج دلخواه در پنل کاربری وی پی سی",
    imgTitle: "بارگذاری ایمیج دلخواه در پنل کاربری وی پی سی",
  },
  {
    title: "منابع و تعداد آی‌پی نامحدود",
    desc: "با خرید وی پی سی، بدون نگرانی از محدودیت منابع یا تعداد آی‌پی، همه سرورهای خود را بسازید.",
    logo: "resource.svg",
    imgAlt: "منابع و تعداد آی‌پی نامحدود با خرید VPC",
    imgTitle: "منابع و تعداد آی‌پی نامحدود با خرید VPC",
  },
  {
    title: "پیاده‌سازی معماری ابری دلخواه",
    desc: "پیچیده‌ترین سناریوهای معماری ابری را که متصور هستید، در پنل دیتاسنتر ابری پیاده کنید.",
    logo: "architect.svg",
    imgAlt: "پیاده‌سازی معماری ابری دلخواه با خرید وی پی سی",
    imgTitle: "پیاده‌سازی معماری ابری دلخواه با خرید وی پی سی",
  },
  {
    title: "افزایش یا کاهش سریع منابع",
    desc: "با دیتاسنتر ابری، در هر لحظه، منابع هر VM یا کل دیتاسنتر را به سادگی افزایش یا کاهش دهید.",
    logo: "increase.svg",
    imgAlt: "افزایش یا کاهش سریع منابع در پنل وی پی سی",
    imgTitle: "افزایش یا کاهش سریع منابع در پنل وی پی سی",
  },
  {
    title: "پشتیبانی ۲۴/۷/۳۶۵",
    desc: "با خرید VPC، از پشتیبانی رایگان همه روزه و در تمامی ساعات شبانه‌روز بهره‌مند شوید.",
    logo: "24.svg",
    imgAlt: "پشتیبانی ۲۴ ساعته دیتاسنتر ابری",
    imgTitle: "پشتیبانی ۲۴ ساعته دیتاسنتر ابری",
  },
  {
    title: "فایروال پیشرفته قابل تنظیم",
    desc: "رول‌های فایروال پیشرفته را در پنل وی پی سی ایجاد کرده و از سرورها محافظت نمایید.",
    logo: "firewall-new.svg",
    imgAlt: "فایروال پیشرفته وی پی سی",
    imgTitle: "فایروال پیشرفته وی پی سی",
  },
  {
    title: "آپ‌تایم تا ۹۹.۹۹ درصد",
    desc: "دیتاسنتر ابری آبالون با بالاترین میزان آپ‌تایم، تا ۹۹.۹۹ درصد در اختیارتان قرار می‌گیرد.",
    logo: "uptime.svg",
    imgAlt: "حداکثر آپ‌تایم در دیتاسنتر ابری",
    imgTitle: "حداکثر آپ‌تایم در دیتاسنتر ابری",
  },
];
export default {
  dataBlog,
  benefits,
  benefits2,
  questions,
  uses,
  customers,
  serviceFeatures,
  PopularServices,
};
